import SearchIcon from '@material-ui/icons/Search';

export default function FormEditProjectAirSubstation({ dados, ...props }) {
  return (
    <>
      <section>
        <h4>Especificações do Projeto</h4>

        <div className="div__multiColumn">
          <input
            id="existing_transformer_power"
            type="text"
            name="data.existing_transformer_power"
            placeholder="Potência do transformador existente"
            className="input-custom-style"
            value={dados?.data?.existing_transformer_power || ''}
            onChange={props.onInputChange}
            style={{ flex: 1 }}
          />

          <input
            id="new_transformer_power"
            type="text"
            name="data.new_transformer_power"
            placeholder="Nova potência do transformador"
            className="input-custom-style"
            value={dados?.data?.new_transformer_power || ''}
            onChange={props.onInputChange}
            style={{ flex: 1 }}
          />
        </div>

        <div className="div__multiColumn" style={{ maxWidth: '530px' }}>
          <input
            className="input-custom-style "
            type="number"
            placeholder={'Latitude do projeto'}
            value={dados.latitude || ''}
            onChange={props.onInputChange}
            name={'latitude'}
            style={{ flex: 1 }}
            required
          />
          <input
            className="input-custom-style "
            type="number"
            placeholder={'Longitude do projeto'}
            value={dados.longitude || ''}
            onChange={props.onInputChange}
            name={'longitude'}
            style={{ flex: 1 }}
            required
          />

          <button
            type="button"
            className="tertiary-button-style"
            style={{
              alignItems: 'center',
              display: 'flex',
            }}
            onClick={() => props.setShowCoord(!props.showCoord)}
          >
            <SearchIcon /> Buscar
          </button>
        </div>
      </section>
    </>
  );
}
